import { render, staticRenderFns } from "./WidgetConfig.vue?vue&type=template&id=65c2c3e5&scoped=true&"
import script from "./WidgetConfig.vue?vue&type=script&lang=js&"
export * from "./WidgetConfig.vue?vue&type=script&lang=js&"
import style0 from "./WidgetConfig.vue?vue&type=style&index=0&id=65c2c3e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c2c3e5",
  null
  
)

export default component.exports